import { RedoTextInput } from "@redotech/arbiter/input/redo-text-input";
import { groupInput, input, InputSchema } from "@redotech/ui/form";
import { nonEmptyValidator } from "@redotech/ui/validators";
import { memo } from "react";

export const EPostGlobalCarrierInput = groupInput({
  account_number: input<string>({ validator: nonEmptyValidator }),
});

export type EPostGlobalCarrierValue = InputSchema.Value<
  typeof EPostGlobalCarrierInput
>;

export type EPostGlobalCarrierForm = InputSchema.Input<
  typeof EPostGlobalCarrierInput
>;

export const EPostGlobalCarrierDefault = (): EPostGlobalCarrierValue => ({
  account_number: "",
});

export const CreateEPostGlobalCarrierForm = memo(
  function CreateEPostGlobalCarrierForm({
    carrierInput,
  }: {
    carrierInput: EPostGlobalCarrierForm;
  }) {
    return (
      <RedoTextInput
        label="Account number"
        placeholder=""
        setValue={carrierInput.inputs.account_number.setValue}
        value={carrierInput.inputs.account_number.value}
      />
    );
  },
);
